<template>
  <div v-if="!$store.getters['user/getUserFields'].is_admin">
    Вы не администратор, авторизируйтесь как администратор!
  </div>
  <div v-else class="render">
    <v-overlay :value="replacing" opacity="0.6">
      <div class="overlay-box">
        <v-progress-circular indeterminate size="28" class="mr-3" />
        <div>
          <div class="overlay-title">Идёт замена номеров…</div>
          <div class="overlay-sub">
            Старые номера переводим в утиль, создаём новую карусель
          </div>
        </div>
      </div>
    </v-overlay>

    <v-snackbar v-model="snack.show" timeout="4000">{{
      snack.text
    }}</v-snackbar>

    <SelectNumbersModal
      v-model="modalSelect"
      ref="selModal"
      :mode="selectMode"
      :carousels="selects.carousels"
      :users="selects.users"
      :is-admin="true"
      @created="refreshCurrent"
      @confirm="handleConfirmReplace"
    />
    <ReserveMarkingModal
      v-model="modalReserve"
      :mode="reserveMode"
      :is-admin="true"
      :users="selects.users"
      :reserve="editingReserve"
      :status="editingReserve?.status || 'review'"
      :markings="selects.markings"
      @create="onReserveCreate"
      @save="onReserveSave"
    />
    <EditCarouselModal
      v-model="modalEdit"
      :carousel="editingCarousel"
      :is-admin="true"
      @save="saveCarousel"
    />
    <ReserveActionConfirm
      v-model="modalAction"
      :kind="actionKind"
      :row="actionRow"
      @ok="performAction"
      @cancel="
        () => {
          actionRow = null;
        }
      "
    />
    <EditOpPriceModal
      v-model="modalEditPrice"
      :op="editingOp"
      @save="saveOpPrice"
    />

    <div class="top"><h1>Карусели пользователей</h1></div>

    <div class="my_toolbar">
      <v-tabs v-model="tab" align-with-title class="tabs">
        <v-tabs-slider color="#4B5EFF" />
        <v-tab
          v-for="t in tabs"
          :key="t"
          class="item_tab"
          active-class="my_active_tab"
          >{{ t }}</v-tab
        >
      </v-tabs>

      <v-btn
        v-if="tab === 0"
        class="select-btn"
        :disabled="replacing"
        @click="openSelectNumbers"
      >
        <Icon name="white_plus" class="mr-2" /> Выделить номера пользователю
      </v-btn>

      <v-btn
        v-if="tab === 1"
        class="reserve-btn"
        :disabled="replacing"
        @click="openReserveModal"
      >
        <Icon name="white_plus" class="mr-2" /> Добавить резерв номеров с
        маркировкой
      </v-btn>
    </div>

    <div class="content_table">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <FilterReports
            page_type="users_carousels"
            :filter-config="filtersConfig.userCarousels"
            :selects="selects"
            :callback="fetchUserCarousels"
            :show-period="true"
            @export="exportUserCarousels"
          />
          <Table
            :loading="loading.userCarousels || replacing"
            :headers="headers.userCarousels"
            :data="tables.userCarousels"
            :perPage="10"
            :callback_refresh="fetchUserCarousels"
            :hideselect="true"
            :items="actionItemsCarousel"
            :items-fn="userCarouselActions"
            page_type="users_carousels"
            @edit="editCarousel"
            @replace="startReplace"
            @delete="deleteCarousel"
            @export="exportUserCarouselRow"
            @toggle-carousel="toggleUserCarousel"
          />
        </v-tab-item>
        <v-tab-item>
          <FilterReports
            page_type="user_reserves"
            :filter-config="filtersConfig.reserves"
            :selects="selects"
            :callback="fetchReserves"
            :show-period="true"
            @export="exportReserves"
          />
          <Table
            :loading="loading.reserves"
            :headers="headers.reserves"
            :data="tables.reserves"
            :perPage="10"
            :callback_refresh="fetchReserves"
            :hideselect="false"
            page_type="user_reserves"
            :items="actionItemsReserves"
            :items-fn="reserveActions"
            @activate="reserveActivate"
            @confirm="reserveConfirm"
            @edit="reserveEdit"
            @export="reserveExport"
            @delete="reserveDelete"
          />
        </v-tab-item>
        <v-tab-item>
          <FilterReports
            page_type="ops_history"
            :filter-config="filtersConfig.opsHistory"
            :selects="selects"
            :callback="fetchOpsHistory"
            :show-period="true"
            @export="exportOpsHistory"
          />

          <Table
            :loading="loading.opsHistory"
            :headers="headers.opsHistory"
            :data="tables.opsHistory"
            :perPage="10"
            :callback_refresh="fetchOpsHistory"
            :hideselect="true"
            page_type="ops_history"
            :items="actionItemsOpsHistory"
            @edit_price="editOpsPrice"
          />
        </v-tab-item>
        <v-tab-item>
          <FilterReports
            page_type="user_trunk_group"
            :filter-config="filtersConfig.userTrunk"
            :selects="selects"
            :callback="fetchUserTrunk"
            :show-period="false"
            @export="exportUserCarousels"
          />
          <Table
            :loading="loading.userTrunk"
            :headers="headers.userTrunk"
            :data="tables.userTrunk"
            :perPage="10"
            :callback_refresh="fetchUserTrunk"
            :hideselect="true"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table/DataTable.vue';
import FilterReports from '@/components/Filter/ReportsFilter.vue';
import SelectNumbersModal from '@/components/SelectNumbersModal.vue';
import EditCarouselModal from '@/components/EditCarouselModal.vue';
import EditOpPriceModal from '@/components/EditOpPriceModal.vue';
import Icon from '@/components/SetIcon.vue';
import ReserveMarkingModal from '@/components/ReserveMarkingModal.vue';
import ReserveActionConfirm from '@/components/ReserveActionConfirm.vue';

const OP_LABELS_RU = {
  create: 'Создание',
  replace: 'Замена',
  auto_replace: 'Автозамена',
  auto_renew: 'Автопродление',
  delete: 'Удаление',
  settings: 'Настройки',
};

export default {
  name: 'UsersCarouselsPage',
  components: {
    Table,
    FilterReports,
    SelectNumbersModal,
    EditCarouselModal,
    EditOpPriceModal,
    Icon,
    ReserveMarkingModal,
    ReserveActionConfirm,
  },

  data() {
    return {
      modalAction: false,
      actionKind: 'confirm',
      actionRow: null,
      editingReserve: null,
      modalReserve: false,
      reserveMode: 'create',
      modalEditPrice: false,
      editingOp: null,
      tab: 0,
      tabs: [
        'Карусели пользователей',
        'Резервы пользователей с маркировкой',
        'История операций',
        'Юзер – транк-группа',
      ],
      loading: {
        userCarousels: false,
        reserves: false,
        opsHistory: false,
        userTrunk: false,
      },
      snack: { show: false, text: '' },
      replacing: false,

      modalSelect: false,
      modalEdit: false,
      selectMode: 'new',
      editingCarousel: null,

      selects: {
        users: [],
        carousels: [],
        user_carousels: [],
        reserve_statuses: [
          { id: 'pending', name: 'Согласование' },
          { id: 'active', name: 'Активен' },
          { id: 'review', name: 'На проверке' },
        ],
        markings: [],
        carousel_statuses: [
          { id: 'active', name: 'Активна' },
          { id: 'in', name: 'Только входящие' },
        ],
        op_types: [
          { id: 'create', name: 'Создание' },
          { id: 'replace', name: 'Замена' },
          { id: 'auto_replace', name: 'Автозамена' },
          { id: 'auto_renew', name: 'Автопродление' },
          { id: 'delete', name: 'Удаление' },
          { id: 'settings', name: 'Настройки' },
        ],
      },

      filtersConfig: {
        userCarousels: [
          {
            type: 'select',
            field: 'user',
            label: 'Пользователь',
            items: 'users',
          },
          {
            type: 'select',
            field: 'status',
            label: 'Статус карусели',
            items: 'carousel_statuses',
          },
          {
            type: 'select',
            field: 'carousel',
            label: 'Карусель',
            items: 'carousels',
          },
          { type: 'range', field: 'calls', label: 'Звонков с 1 номера' },
        ],
        opsHistory: [
          {
            type: 'select',
            field: 'user',
            label: 'Пользователь',
            items: 'users',
          },
          {
            type: 'select',
            field: 'op_type',
            label: 'Тип операции',
            items: 'op_types',
          },
          {
            type: 'select',
            field: 'carousel',
            label: 'Карусель',
            items: 'carousels',
          },
        ],
        reserves: [
          { type: 'period', field: 'created_period', label: 'Период создания' },
          {
            type: 'select',
            field: 'user',
            label: 'Пользователь',
            items: 'users',
          },
          {
            type: 'select',
            field: 'status',
            label: 'Статус резерва',
            items: 'reserve_statuses',
          },
          {
            type: 'select',
            field: 'marking',
            label: 'Маркировка',
            items: 'markings',
          },
        ],
        userTrunk: [
          {
            type: 'select',
            field: 'user',
            label: 'Пользователь',
            items: 'users',
          },
          {
            type: 'select',
            field: 'trunk_group',
            label: 'Группа транков',
            items: 'trunk_groups',
          },
          {
            type: 'select',
            field: 'conflict',
            label: 'Конфликт',
            items: 'yesno',
          },
          {
            type: 'select',
            field: 'carousel',
            label: 'Карусель',
            items: 'user_carousels',
          },
        ],
      },

      tables: {
        userCarousels: [],
        reserves: [],
        opsHistory: [],
        userTrunk: [],
      },
      userCarouselSource: [],
      expandedUserCarousels: {},
      headers: {
        userCarousels: [
          { text: 'Карусель пользователя', value: 'carousel' },
          { text: 'Пользователь', value: 'user' },
          { text: 'Статус карусели', value: 'carouselStatus' },
          { text: 'Количество номеров', value: 'numbersCount' },
          { text: 'Звонков с 1 номера', value: 'callsPerNumber' },
          { text: 'Дата/время создания', value: 'createdAt' },
          { text: 'Окончание аренды', value: 'rentEnd' },
          { text: 'Автопродление', value: 'autoRenew' },
          { text: 'Последняя замена', value: 'lastAutoReplace' },
          { text: 'Последний исходящий вызов', value: 'lastOutboundCall' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
        opsHistory: [
          { text: 'Карусель', value: 'carousel' },
          { text: 'Пользователь', value: 'user' },
          { text: 'Инициатор', value: 'actor' },
          { text: 'Тип операции', value: 'opType' },
          { text: 'Количество номеров', value: 'numbersCount' },
          { text: 'Стоимость', value: 'cost' },
          { text: 'Дата/время', value: 'createdAt' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
        reserves: [
          { text: 'Резерв', value: 'reserve' },
          { text: 'Пользователь', value: 'user' },
          { text: 'Статус', value: 'reserveStatus' },
          { text: 'Количество номеров', value: 'numbersInfo' },
          { text: 'Стоимость аренды', value: 'rentCost' },
          { text: 'Маркировка', value: 'marking' },
          { text: 'Создан', value: 'createdAt' },
          { text: 'Начало аренды', value: 'rentStart' },
          { text: 'Окончание аренды', value: 'rentEnd' },
          { text: 'Автопродление', value: 'autoRenew' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
        userTrunk: [
          { text: 'Пользователь', value: 'user' },
          { text: 'Группа транков', value: 'trunkGroup' },
          { text: 'Активные', value: 'active' },
          { text: 'Только входящие', value: 'inboundOnly' },
          { text: 'Конфликт', value: 'conflict' },
        ],
      },

      actionItemsCarousel: [
        { title: 'Редактировать', action: 'edit' },
        { title: 'Заменить номера', action: 'replace' },
        { title: 'Экспорт', action: 'export' },
        { title: 'Удалить', action: 'delete' },
      ],
      actionItemsOpsHistory: [
        { title: 'Редактировать цену', action: 'edit_price' },
        { title: 'Запаска', action: 'запаска' },
      ],
      actionItemsReserves: [
        { title: 'Подтвердить', action: 'confirm' },
        { title: 'Активировать', action: 'activate' },
        { title: 'Редактировать', action: 'edit' },
        { title: 'Экспорт', action: 'export' },
        { title: 'Удалить', action: 'delete' },
      ],
    };
  },

  created() {
    this.bootstrap();
  },
  watch: {
    tab(v) {
      const label = this.tabs[v];
      if (
        label === 'Резервы пользователей с маркировкой' &&
        this.tables.reserves.length === 0 &&
        !this.loading.reserves
      ) {
        this.fetchReserves({});
      }
      if (
        label === 'История операций' &&
        this.tables.opsHistory.length === 0 &&
        !this.loading.opsHistory
      ) {
        this.fetchOpsHistory({});
      }
    },
  },

  methods: {
    normalizePeriod(filters = {}) {
      const f = { ...filters };

      if (!f.startDate && !f.endDate) {
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');

        const today = `${yyyy}-${mm}-${dd}`;

        f.startDate = today;
        f.endDate = today;

        if (!f.startTime) f.startTime = '00:00';
        if (!f.endTime) f.endTime = '23:59';
      }

      return f;
    },

    async exportOpsHistory(filters = {}) {
      try {
        const f = this.normalizePeriod(filters);

        const chosen = this.pickId(f.user);
        const isAll = !chosen || chosen === '__all__';

        const payload = {
          user: isAll ? '' : this.digits11(chosen),
          op_type: this.pickId(f.op_type) || '',
          carousel: this.pickId(f.carousel) || '',
          startDate: f.startDate,
          endDate: f.endDate,
          startTime: f.startTime,
          endTime: f.endTime,
          group_by_trunk: f.group_by_trunk === true,
        };

        if (sessionStorage.token) {
          payload.token = sessionStorage.token;
        }

        const res = await this.$http.axios.post(
          'numbers/carousel_events/export',
          payload,
          {
            responseType: 'arraybuffer',
            withCredentials: false,
          },
        );

        const cd = res.headers['content-disposition'] || '';
        const ct = (res.headers['content-type'] || '').toLowerCase();

        let filename = 'carousel_events';
        const m = cd.match(/filename="?([^"]+)"?/i);
        if (m && m[1]) {
          filename = m[1];
        } else {
          filename += ct.includes('spreadsheetml.sheet') ? '.xlsx' : '.xlsx';
        }

        const blobType =
          ct ||
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([res.data], { type: blobType });

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);

        this.snack = {
          show: true,
          text: 'Экспорт истории операций сформирован',
        };
      } catch (e) {
        console.error('exportOpsHistory failed:', e);
        this.snack = { show: true, text: 'Экспорт истории операций не удался' };
      }
    },

    async fetchOpsHistory(filters = {}) {
      this.loading.opsHistory = true;

      const f = this.normalizePeriod(filters);
      const chosen = this.pickId(f.user);
      const isAll = !chosen || chosen === '__all__';

      try {
        const payload = {
          user: isAll ? '' : this.digits11(chosen),
          op_type: this.pickId(f.op_type) || '',
          carousel: this.pickId(f.carousel) || '',
          startDate: f.startDate,
          endDate: f.endDate,
          startTime: f.startTime,
          endTime: f.endTime,
          limit: 600,
        };

        const resp = await this.apiPost('/numbers/carousel_events', payload);
        const rows = Array.isArray(resp) ? resp : [];

        this.tables.opsHistory = rows.map((r) => ({
          id: r.id || r.carousel_id,
          carousel: r.carousel_title || r.carouselTitle || '—',
          user: String(r.owner_user || r.ownerUser || '—'),
          actor:
            String(r.actor_role || '').toLowerCase() === 'system' ||
            !r.actor_user ||
            Number(r.actor_user) === 0
              ? 'Система'
              : String(r.actor_user),
          opType:
            OP_LABELS_RU[(r.operation || '').toLowerCase()] ||
            r.operation ||
            '—',
          numbersCount: Number(r.numbers_count ?? r.numbersCount ?? 0),
          cost: this.fmtRub(r.amount ?? 0),
          createdAt: this.fmtDateTime(
            r.event_time || r.created_at || r.createdAt,
          ),
        }));

        this.$nextTick(() => this.$forceUpdate());

        if (!this.selects.carousels || this.selects.carousels.length === 0) {
          const uniq = [];
          const seen = new Set();
          for (const r of rows) {
            const id = r.carousel_id;
            const name = r.carousel_title || r.carouselTitle;
            if (id && name && !seen.has(id)) {
              seen.add(id);
              uniq.push({ id, name });
            }
          }
          this.selects.carousels = uniq;
        }

        return true;
      } finally {
        this.loading.opsHistory = false;
      }
    },
    async performAction() {
      const row = this.actionRow || {};
      const kind = this.actionKind;
      this.actionRow = null;

      if (kind === 'confirm') {
        this.loading.reserves = true;
        try {
          const resp = await this.apiPost('/numbers/reserves/confirm', {
            id: row.id,
          });
          if (resp === 'error' || !resp?.ok) {
            this.snack = {
              show: true,
              text: (resp && resp.message) || 'Не удалось подтвердить',
            };
            return;
          }
          this.snack = { show: true, text: 'Заявка переведена в согласование' };
          await this.fetchReserves({});
        } finally {
          this.loading.reserves = false;
        }
      }

      if (kind === 'activate') {
        this.loading.reserves = true;
        try {
          const resp = await this.apiPost('/numbers/reserves/activate', {
            id: row.id,
          });
          if (resp === 'error' || !resp?.ok) {
            this.snack = {
              show: true,
              text: (resp && resp.message) || 'Не удалось активировать',
            };
            return;
          }
          this.snack = { show: true, text: 'Резерв активирован' };
          await this.fetchReserves({});
        } finally {
          this.loading.reserves = false;
        }
      }

      if (kind === 'delete_review' || kind === 'delete_other') {
        this.loading.reserves = true;
        try {
          const resp = await this.apiPost('/numbers/reserves/delete', {
            id: row.id,
          });
          if (resp === 'error' || !resp?.ok) {
            this.snack = {
              show: true,
              text: (resp && resp.message) || 'Не удалось удалить резерв',
            };
            return;
          }
          this.snack = { show: true, text: 'Резерв удалён' };
          await this.fetchReserves({});
        } finally {
          this.loading.reserves = false;
        }
      }
    },
    reserveActions(row, base) {
      const byStatus = {
        review: ['confirm', 'edit', 'delete'],
        pending: ['activate', 'edit', 'export', 'delete'],
        active: ['edit', 'export', 'delete'],
      };
      const code = String(row?.statusCode || '').toLowerCase();
      const allow = byStatus[code] || [];
      return base.filter((it) => allow.includes(it.action));
    },

    async fetchReserves(filters = {}) {
      this.loading.reserves = true;
      try {
        const chosen = this.pickId(filters.user);
        const isAll = !chosen || chosen === '__all__';
        const user11 = isAll ? '' : this.digits11(chosen);

        const base = {
          status: this.pickId(filters.status) || '',
          marking: this.pickId(filters.marking) || '',
          startDate: filters.startDate,
          endDate: filters.endDate,
        };

        if (!isAll) {
          try {
            const m = await this.apiPost('/numbers/markings/list', {
              user: user11,
            });
            const arr = Array.isArray(m?.markings) ? m.markings : [];
            this.selects.markings = arr.map((x) => ({
              id: x.id,
              name: x.name,
            }));
          } catch {
            /* ignore */
          }
        } else {
          this.selects.markings = [];
        }

        const parseDt = (iso) => {
          if (!iso) return 0;
          const s = typeof iso === 'string' ? iso.replace(' ', 'T') : iso;
          const d = new Date(s);
          return isNaN(d) ? 0 : d.getTime();
        };
        const mapRow = (r, userLabel, uid) => {
          const code = String(r.status || '').toLowerCase();
          return {
            id: r.id,

            userId: uid,
            title: r.title || r.reserve || '',
            markingId: r.markingId || null,
            price: Number(r.price || 0) || 0,
            trunks: Array.isArray(r.trunks)
              ? r.trunks.map((t) => ({
                  queueTrunk: String(
                    t.queueTrunk || t.carouselId || t.carousel || '',
                  ),
                  count: Number(t.count || t.numbers || 0) || 0,
                }))
              : [],

            reserve: r.title || r.reserve || '—',
            user: userLabel || uid || '—',
            reserveStatus:
              {
                review: 'На проверке',
                pending: 'Согласование',
                active: 'Активен',
                deleted: 'Удалён',
              }[code] || '—',
            statusCode: code,
            numbersCount: Number(r.numbersCount || 0),
            available: Number(r.available || 0),
            numbersInfo: `${Number(r.available || 0)} / ${Number(
              r.numbersCount || 0,
            )}`,
            rentCost: r.rentCost || '—',
            marking: r.marking || r.markingName || '—',
            createdAt: r.createdAt ? this.fmtDateTime(r.createdAt) : '—',
            _createdAtTs: parseDt(r.createdAt),
            rentStart: r.rentStart || '—',
            rentEnd: r.rentEnd || '—',
            autoRenew: r.autoRenew || '—',
          };
        };

        let out = [];

        if (isAll) {
          const list = (this.selects.users || []).filter(
            (u) => u.id && u.id !== '__all__',
          );
          const chunk = (arr, n) =>
            arr.reduce(
              (a, x, i) => (i % n ? a[a.length - 1].push(x) : a.push([x]), a),
              [],
            );

          for (const part of chunk(list, 8)) {
            const pack = await Promise.all(
              part.map((u) => {
                const uid = this.digits11(u.id);
                return this.apiPost('/numbers/reserves/list', {
                  ...base,
                  user: uid,
                })
                  .then((rows) => ({
                    rows: Array.isArray(rows) ? rows : [],
                    uid,
                    label: u.name || u.id,
                  }))
                  .catch(() => ({ rows: [], uid, label: u.name || u.id }));
              }),
            );
            for (const p of pack) {
              out.push(...p.rows.map((r) => mapRow(r, p.label, p.uid)));
            }
          }
        } else {
          const resp = await this.apiPost('/numbers/reserves/list', {
            ...base,
            user: user11,
          });
          const rows = Array.isArray(resp) ? resp : [];
          const label =
            this.selects.users.find((u) => u.id === chosen)?.name || user11;
          out = rows.map((r) => mapRow(r, label, user11));
        }

        out.sort((a, b) => (b._createdAtTs || 0) - (a._createdAtTs || 0));

        this.tables.reserves = out;
      } finally {
        this.loading.reserves = false;
      }
    },

    async exportReserves(filters = {}) {
      console.log(filters);
      this.snack = {
        show: true,
        text: 'Экспортируйте по кнопке "Экспорт" в строке нужного резерва.',
      };
    },

    reserveConfirm(row) {
      if (!row?.id) return;
      if ((row.statusCode || '') !== 'review') {
        this.snack = {
          show: true,
          text: 'Подтверждать можно только заявки «На проверке»',
        };
        return;
      }
      this.actionKind = 'confirm';
      this.actionRow = row;
      this.modalAction = true;
    },

    reserveActivate(row) {
      if (!row?.id) return;
      if ((row.statusCode || '') !== 'pending') {
        this.snack = {
          show: true,
          text: 'Активировать можно только заявки «Согласование»',
        };
        return;
      }
      this.actionKind = 'activate';
      this.actionRow = row;
      this.modalAction = true;
    },

    reserveDelete(row) {
      if (!row?.id) return;
      const code = (row.statusCode || '').toLowerCase();
      this.actionKind = code === 'review' ? 'delete_review' : 'delete_other';
      this.actionRow = row;
      this.modalAction = true;
    },

    reserveEdit(row) {
      this.reserveMode = 'edit';
      this.editingReserve = {
        id: row.id,
        status: row.statusCode,
        user: row.userId || row.user,
        title: row.title || row.reserve || '',
        markingId: row.markingId || null,
        markingName: row.marking || '',
        price: row.price ?? 0,
        trunks: Array.isArray(row.trunks)
          ? row.trunks
          : [{ queueTrunk: null, count: 0 }],
        autorenew: row.autoRenew === 'Включено',
      };
      this.modalReserve = true;
    },

    async reserveExport(row) {
      if (!row?.id) return;
      try {
        const data = { id: row.id };
        if (sessionStorage.token) data.token = sessionStorage.token;

        const res = await this.$http.axios.post(
          'numbers/reserves/export',
          data,
          {
            responseType: 'arraybuffer',
            withCredentials: false,
          },
        );

        const cd = res.headers['content-disposition'] || '';
        const ct = (res.headers['content-type'] || '').toLowerCase();

        let filename = 'reserve_' + row.id;
        const m = cd.match(/filename="?([^"]+)"?/i);
        if (m && m[1]) {
          filename = m[1];
        } else {
          filename += ct.includes('spreadsheetml.sheet') ? '.xlsx' : '.csv';
        }

        const blobType = ct || 'application/octet-stream';
        const blob = new Blob([res.data], { type: blobType });

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('reserveExport failed:', e);
        this.snack = { show: true, text: 'Экспорт не удался' };
      }
    },
    openReserveModal() {
      this.reserveMode = 'create';
      this.modalReserve = true;
    },
    onReserveCreate(payload) {
      this.snack = {
        show: true,
        text: `Заявка создана (черновик): ${
          payload.totalCount
        } шт. на ${this.fmtRub(payload.total)}`,
      };
      this.editingReserve = null;
      this.reserveMode = 'create';
      this.fetchReserves({ user: payload.user });
    },
    onReserveSave(payload) {
      const user = this.editingReserve?.user || payload.user;
      this.editingReserve = null;
      this.reserveMode = 'create';
      this.snack = { show: true, text: `Изменения сохранены (черновик)` };
      this.fetchReserves({ user });
    },
    apiPost(url, payload) {
      return new Promise((resolve) =>
        this.$http.post(url, payload, (r) => resolve(r)),
      );
    },
    pickId(v) {
      return v && typeof v === 'object'
        ? v.id ?? v.value ?? v._id ?? v.name ?? v.label ?? ''
        : v;
    },
    digits11(v) {
      return String(v || '').replace(/\D/g, '');
    },
    fmtRub(v) {
      const n = Number(v || 0);
      try {
        return new Intl.NumberFormat('ru-RU').format(n) + ' ₽';
      } catch {
        return n + ' ₽';
      }
    },
    fmtDateTime(iso) {
      if (!iso) return '—';
      const safe = typeof iso === 'string' ? iso.replace(' ', 'T') : iso;
      const d = new Date(safe);
      if (isNaN(d)) return '—';
      const p = (n) => String(n).padStart(2, '0');
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(
        d.getHours(),
      )}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },

    async bootstrap() {
      const res = await this.apiPost(
        '/numbers/selects_for_users_carousels',
        {},
      );
      this.selects.users = [{ id: '__all__', name: 'Все пользователи' }].concat(
        res?.users || [],
      );
      await this.fetchUserCarousels({});
      await this.fetchOpsHistory({});
    },
    refreshCurrent() {
      this.fetchUserCarousels({});
    },
    userCarouselActions(row, items) {
      if (row.rowType === 'segment') {
        return items.filter(
          (item) => item.action === 'edit' || item.action === 'replace',
        );
      }

      return items;
    },
    buildUserCarouselRows(source) {
      const rows = [];

      for (const carousel of source || []) {
        const segments = Array.isArray(carousel.segments)
          ? carousel.segments
          : [];

        const parent = {
          ...carousel,
          id: carousel.id,
          guid: carousel.id,
          carouselId: carousel.id,
          rowType: 'parent',
          selectDisabled: false,
          expanded: this.expandedUserCarousels[carousel.id] === true,
        };

        rows.push(parent);

        if (carousel.carouselType !== 'operator' || !parent.expanded) {
          continue;
        }

        for (const segment of segments) {
          const segmentKey = segment.key || segment.segment;

          rows.push({
            ...parent,
            ...segment,

            id: `${carousel.id}:${segmentKey}`,
            guid: `${carousel.id}:${segmentKey}`,
            carouselId: carousel.id,

            rowType: 'segment',
            selectDisabled: true,
            segment: segmentKey,
            carousel: segment.title || segmentKey,

            user: parent.user,
            userId: parent.userId,

            numbersCount: Number(segment.numbersCount || segment.count || 0),
            callsPerNumber: Number(segment.callsPerNumber || 0),

            createdAt: segment.createdAt || '—',
            rentEnd: segment.rentEnd || '—',
            autoRenew: segment.autoRenew || '—',
            lastAutoReplace: segment.lastAutoReplace || '—',
            lastOutboundCall: segment.lastOutboundCall || '—',
          });
        }
      }

      return rows;
    },

    toggleUserCarousel(row) {
      if (row.rowType !== 'parent' || row.carouselType !== 'operator') {
        return;
      }

      const current = this.expandedUserCarousels[row.carouselId] === true;

      this.$set(this.expandedUserCarousels, row.carouselId, !current);

      this.tables.userCarousels = this.buildUserCarouselRows(
        this.userCarouselSource,
      );
    },

    async fetchUserCarousels(filters = {}) {
      this.loading.userCarousels = true;
      try {
        const chosen = this.pickId(filters.user);
        const isAll = !chosen || chosen === '__all__';
        const base = {
          status: this.pickId(filters.status) || '',
          carousel: this.pickId(filters.carousel) || '',
          calls_from: filters.calls?.min ?? null,
          calls_to: filters.calls?.max ?? null,
          startDate: filters.startDate,
          endDate: filters.endDate,
          startTime: filters.startTime,
          endTime: filters.endTime,
        };

        let rows = [];
        if (isAll) {
          const list = (this.selects.users || []).filter(
            (u) => u.id && u.id !== '__all__',
          );
          const chunk = (arr, n) =>
            arr.reduce(
              (a, x, i) => (i % n ? a[a.length - 1].push(x) : a.push([x]), a),
              [],
            );
          for (const part of chunk(list, 5)) {
            const pack = await Promise.all(
              part.map((u) =>
                this.apiPost('/numbers/carousel', {
                  ...base,
                  user: this.digits11(u.id),
                }),
              ),
            );
            pack.forEach((resp, idx) => {
              if (resp !== 'error' && Array.isArray(resp)) {
                const uid = this.digits11(part[idx].id);
                const uname = part[idx].name || part[idx].id;
                rows.push(
                  ...resp.map((r) => ({ ...r, user: uname, userId: uid })),
                );
              }
            });
          }
        } else {
          const user11 = this.digits11(chosen);
          const resp = await this.apiPost('/numbers/carousel', {
            ...base,
            user: user11,
          });
          if (resp !== 'error' && Array.isArray(resp)) {
            const uname =
              this.selects.users.find((u) => u.id === chosen)?.name || user11;
            rows = resp.map((r) => ({ ...r, user: uname, userId: user11 }));
          }
        }

        this.userCarouselSource = rows;

        this.tables.userCarousels = this.buildUserCarouselRows(
          this.userCarouselSource,
        );

        const uniq = [];
        const seen = new Set();
        for (const r of rows)
          if (r?.id && !seen.has(r.id)) {
            seen.add(r.id);
            uniq.push({ id: r.id, name: r.carousel });
          }
        this.selects.carousels = uniq;
      } finally {
        this.loading.userCarousels = false;
      }
    },

    openSelectNumbers() {
      this.selectMode = 'new';
      this.modalSelect = true;
      this.$nextTick(() => {
        const dlg = this.$refs.selModal;
        if (dlg) {
          dlg.type = 'new';
          dlg.selectedCarousel = null;
          dlg.selectedSegment = null;
          dlg.selectedTrunk = null;
          dlg.selectedUser = null;
        }
      });
    },

    startReplace(row) {
      this.selectMode = 'replace';
      this.modalSelect = true;

      this.$nextTick(() => {
        const dlg = this.$refs.selModal;

        if (dlg) {
          dlg.type = 'replace';

          dlg.selectedCarousel = row.carouselId || row.id;
          dlg.selectedSegment = row.rowType === 'segment' ? row.segment : null;
          dlg.selectedTrunk = row.rowType === 'segment' ? row.trunk : null;

          dlg.selectedUser = row.userId;
          dlg.numbersKind = 'regular';

          if (row.rowType === 'segment') {
            dlg.amount = Number(row.numbersCount || row.count || 0);
          }

          dlg.loadCarouselCountRule();
        }
      });
    },
    handleConfirmReplace({ carouselId, segment, amount, user }) {
      this.replacing = true;

      this.$http.post(
        '/numbers/carousel/replace_numbers',
        {
          carouselId,
          segment: segment || undefined,
          count: Number(amount),
          user,
        },
        (res) => {
          this.replacing = false;

          if (res === 'error' || !res?.ok) {
            this.snack = {
              show: true,
              text:
                (res && res.message) || 'Ошибка: не удалось заменить номера',
            };
            return;
          }

          this.snack = {
            show: true,
            text: segment
              ? 'Сегмент успешно заменён'
              : 'Замена карусели выполнена',
          };

          this.fetchUserCarousels({});
          this.fetchOpsHistory({});
        },
      );
    },

    editCarousel(row) {
      this.editingCarousel = {
        id: row.carouselId || row.id,
        segment: row.segment || null,

        user: row.user,
        title: row.carousel,
        status: row.carouselStatus === 'Активна' ? 'active' : 'in',

        autorenew: row.autoRenew === 'Включено',
        autoreplace: Boolean(row.autoReplaceOn),

        days: row.days || ['mon'],
        time: row.time || '20:00',
        amount: Number(row.amount || row.numbersCount || 0),

        autoPrice: row.autoPrice ?? null,

        incoming_script_id: row.incoming_script_id || row.scriptId || null,

        autoSource: row.auto_source ?? row.autoSource ?? 'regular',

        autoReserveId: row.auto_reserve_id ?? row.autoReserveId ?? null,

        auto_replace_type:
          row.auto_replace_type || row.autoReplaceType || 'schedule',

        auto_calls_threshold: Number(
          row.auto_calls_threshold || row.autoCallsThreshold || 10,
        ),

        auto_schedule_json: row.auto_schedule_json || '',

        rowType: row.rowType,
        carouselType: row.carouselType,
      };

      this.modalEdit = true;
    },
    saveCarousel(form) {
      if (!this.editingCarousel?.id) {
        this.modalEdit = false;
        return;
      }

      const isSegment = Boolean(this.editingCarousel.segment);

      const isOperatorParent =
        this.editingCarousel.rowType === 'parent' &&
        this.editingCarousel.carouselType === 'operator';

      const commonSettings = {
        title: form.title,
        status: form.status,
        autorenew: Boolean(form.autorenew),

        incoming_script_id: form.incoming_script_id ?? form.scriptId ?? '',
      };

      const autoSettings = {
        autoreplace: Boolean(form.autoreplace),

        days: Array.isArray(form.days) ? form.days : [],

        time: form.time,
        amount: Number(form.amount) || 0,

        auto_source: form.auto_source ?? form.autoSource ?? 'regular',

        auto_reserve_id: form.auto_reserve_id ?? form.autoReserveId ?? '',

        auto_replace_type:
          form.auto_replace_type ?? form.autoReplaceType ?? 'schedule',

        auto_calls_threshold: Math.max(
          10,
          Number(form.auto_calls_threshold ?? form.autoCallsThreshold ?? 10) ||
            10,
        ),

        auto_schedule_json: form.auto_schedule_json || '',
      };

      const payload = {
        id: this.editingCarousel.id,

        ...(isSegment
          ? {
              segment: this.editingCarousel.segment,
              ...autoSettings,
            }
          : isOperatorParent
          ? commonSettings
          : {
              ...commonSettings,
              ...autoSettings,
            }),
      };

      console.log('[carousel_update payload]', payload);

      this.$http.post('/numbers/carousel_update', payload, (resp) => {
        if (resp === 'error' || !resp?.ok) {
          this.snack = {
            show: true,
            text: (resp && resp.message) || 'Не удалось сохранить настройки',
          };
          return;
        }

        this.modalEdit = false;

        this.snack = {
          show: true,
          text: 'Настройки сохранены',
        };

        this.fetchUserCarousels({});
        this.fetchOpsHistory({});
      });
    },

    deleteCarousel(row) {
      if (
        !confirm(
          `Удалить карусель «${row.carousel}»?\nЭто действие необратимо.`,
        )
      )
        return;
      this.$http.post('/numbers/carousel_delete', { id: row.id }, (res) => {
        if (res === 'error' || !res?.ok) {
          alert('Ошибка: не удалось удалить карусель');
          return;
        }
        this.fetchUserCarousels({});
        this.fetchOpsHistory({});
      });
    },

    editOpsPrice(row) {
      const total =
        Number(
          String(row.cost || '')
            .replace(/[^\d.,]/g, '')
            .replace(',', '.'),
        ) || 0;
      const n = Number(row.numbersCount || 0);
      const price = n > 0 ? +(total / n).toFixed(2) : 0;
      this.editingOp = {
        id: row.id,
        numbersCount: n,
        price,
        carousel: row.carousel,
        user: row.user,
      };
      this.modalEditPrice = true;
    },
    async saveOpPrice({ total }) {
      const id = this.editingOp?.id;
      if (!id) return;
      this.loading.opsHistory = true;
      try {
        const resp = await this.apiPost(
          '/numbers/carousel_events/update_price',
          { id, amount: total },
        );
        if (resp === 'error' || !resp?.ok) {
          this.snack = {
            show: true,
            text: (resp && resp.message) || 'Не удалось сохранить',
          };
          return;
        }
        this.snack = { show: true, text: 'Цена операции обновлена' };
        const idx = this.tables.opsHistory.findIndex((r) => r.id === id);
        if (idx >= 0) {
          const row = this.tables.opsHistory[idx];
          this.$set(this.tables.opsHistory, idx, {
            ...row,
            cost: this.fmtRub(total),
          });
        }
      } finally {
        this.loading.opsHistory = false;
      }
    },

    async fetchUserTrunk(filters = {}) {
      this.loading.userTrunk = true;
      try {
        const chosen = this.pickId(filters.user);
        if (!chosen || chosen === '__all__') {
          this.tables.userTrunk = [];
          this.selects.trunk_groups = [];
          this.selects.user_carousels = [];
          return;
        }
        const payload = {
          user: this.digits11(chosen),
          trunk_group: this.pickId(filters.trunk_group) || '',
          carousel: this.pickId(filters.carousel) || '',
        };
        try {
          const onlyUserCars = await this.apiPost('/numbers/carousel', {
            user: payload.user,
            status: '',
            carousel: '',
            calls_from: null,
            calls_to: null,
            startDate: null,
            endDate: null,
            startTime: null,
            endTime: null,
          });
          const list = Array.isArray(onlyUserCars) ? onlyUserCars : [];
          this.selects.user_carousels = list
            .filter((r) => r?.id && r?.carousel)
            .map((r) => ({ id: r.id, name: r.carousel }));
        } catch (e) {
          this.selects.user_carousels = [];
        }
        const resp = await this.apiPost('/numbers/user_trunk_group', payload);
        const rows = Array.isArray(resp?.rows) ? resp.rows : [];

        this.tables.userTrunk = rows.map((r) => ({
          user: r.user || payload.user,
          trunkGroup: r.trunkGroup,
          active: Number(r.active || 0),
          inboundOnly: Number(r.inboundOnly || 0),
          conflict: '—',
        }));

        const tgs = Array.isArray(resp?.trunk_groups) ? resp.trunk_groups : [];
        this.selects.trunk_groups = tgs.map((x) => ({ id: x, name: x }));
      } finally {
        this.loading.userTrunk = false;
      }
    },

    formatRuPhone(val) {
      const s = String(val || '');
      const digits = s.replace(/\D/g, '');
      if (digits.length < 10) return s;

      const local = digits.slice(-10);
      return `+7 (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(
        6,
        8,
      )}-${local.slice(8, 10)}`;
    },

    fmtDateOnly(val) {
      if (!val) return '—';
      if (/^\d{2}\.\d{2}\.\d{4}$/.test(String(val))) return String(val);

      const safe = String(val).replace(' ', 'T');
      const d = new Date(safe);

      if (isNaN(d)) {
        const m = String(val).match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return `${m[3]}.${m[2]}.${m[1]}`;
        return '—';
      }

      const p = (n) => String(n).padStart(2, '0');
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
    },

    async exportXlsx(fileName, sheetName, rows = []) {
      if (!Array.isArray(rows) || !rows.length) {
        this.snack = { show: true, text: 'Нет данных для экспорта' };
        return;
      }

      const { default: ExcelJS } = await import('exceljs');

      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet(sheetName);

      const headers = Object.keys(rows[0]);
      ws.addRow(headers);

      rows.forEach((row) => {
        ws.addRow(headers.map((key) => row[key]));
      });

      ws.getRow(1).font = { bold: true };

      ws.columns = headers.map((key) => ({
        key,
        width: Math.min(
          40,
          Math.max(
            String(key).length + 2,
            ...rows.map((row) => String(row[key] ?? '').length + 2),
          ),
        ),
      }));

      const buffer = await wb.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },

    async exportUserCarouselRow(row) {
      try {
        this.loading.userCarousels = true;

        if (!row?.id) {
          this.snack = { show: true, text: 'Не найдена карусель для экспорта' };
          return;
        }

        const payload = {
          carousel: row.id,
          user: row.userId,
        };

        const resp = await this.apiPost('/numbers/all', payload);

        if (resp === 'error' || !Array.isArray(resp) || !resp.length) {
          this.snack = { show: true, text: 'Нет номеров для экспорта' };
          return;
        }

        const rows = resp.map((r) => ({
          Номер: this.formatRuPhone(r.phoneNumber),
          'Исходящих звонков совершено': r.outboundCalls ?? '—',
          Карусель: r.carousel ?? '—',
          'Статус карусели': r.carouselStatus ?? '—',
          'Начало аренды': this.fmtDateOnly(r.rentStart),
          'Окончание аренды': this.fmtDateOnly(r.rentEnd),
          'Стоимость аренды': r.rentCost ?? '—',
          Автопродление: r.autoRenew ?? '—',
          'Последний исходящий вызов': this.fmtDateOnly(r.lastOutboundCall),
        }));

        const safeName = String(row.carousel || 'carousel')
          .replace(/[^\wа-яА-ЯёЁ-]+/g, '_')
          .replace(/_+/g, '_')
          .replace(/^_+|_+$/g, '');

        await this.exportXlsx(
          `${safeName || 'carousel'}.xlsx`,
          'Numbers',
          rows,
        );
      } catch (e) {
        console.error('exportUserCarouselRow failed:', e);
        this.snack = { show: true, text: 'Экспорт не удался' };
      } finally {
        this.loading.userCarousels = false;
      }
    },

    exportUserCarousels() {
      alert('Экспорт пока недоступен.');
    },
  },
};
</script>

<style scoped>
.content_table {
  margin-top: 24px;
}
.my_toolbar {
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
}
.tabs {
  flex: 1;
}
.select-btn {
  height: 40px;
  background: #4b5eff !important;
  border-radius: 8px !important;
  font: 600 15px/120% inherit;
  color: #fff !important;
  text-transform: none;
  padding: 10px 22px;
  display: flex;
  align-items: center;
}
.item_tab {
  text-transform: none !important;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #808185;
}
.my_active_tab {
  color: #2b2d33;
}
.overlay-box {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 16px 20px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.overlay-title {
  font: 700 16px/1.2 Manrope, sans-serif;
  color: #2b2d33;
}
.overlay-sub {
  font: 500 13px/1.3 Manrope, sans-serif;
  color: #6f7075;
  margin-top: 4px;
}
.reserve-btn {
  height: 40px;
  background: #4b5eff !important;
  border-radius: 8px !important;
  font: 600 15px/120% inherit;
  color: #fff !important;
  text-transform: none;
  padding: 10px 22px;
  display: flex;
  align-items: center;
}
</style>
